import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotificationService } from '../../shared/services/notification.service';
import { MaterialModule } from 'src/app/app.materials';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['../login/login.component.scss'],
  standalone: true,
  imports: [MaterialModule, CommonModule, RouterModule]
})
export class VerifyComponent implements OnInit {
  token = '';
  isLoading = true;
  isSuccess = false;
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params.token) {
        this.token = params.token;
        this.verifyEmail();
      } else {
        this.isLoading = false;
        this.errorMessage = 'No verification token provided.';
      }
    });
  }

  verifyEmail() {
    this.isLoading = true;
    this.authService.verifyEmail(this.token).subscribe((resp: any) => {
      this.isLoading = false;
      if (resp.success) {
        this.isSuccess = true;
        this.notificationService.open('Email verified successfully! You can now login.');
      } else {
        this.isSuccess = false;
        this.errorMessage = resp.error || 'Verification failed. The token may be invalid or expired.';
      }
    }, (error) => {
      this.isLoading = false;
      this.isSuccess = false;
      this.errorMessage = 'Verification failed. The token may be invalid or expired.';
    });
  }
}
